import { render } from "./SheetDataSettings.vue?vue&type=template&id=c6518ba6"
import script from "./SheetDataSettings.vue?vue&type=script&lang=js"
export * from "./SheetDataSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__